/***
 * Created on 2025/4/29
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useRegion} from "../../context/RegionContext";
import {useOrganization} from "../../context/OrganizationContext";

function CloudSpaceRegionComponent({region_code, with_link=false}) {
    const { t } = useTranslation();
    const [flagImage, setFlagImage] = useState(null);
    const { url } = useRegion();
    const {getCurrentOrg} = useOrganization();
    const org = getCurrentOrg();

    const genLink = (region_code) => {
        return `${url.get_myqnapcloud_fe_url()}/u#!/my_space?tab=org_space&org_id=${org.organization_id}&region=${region_code}`;
    }

    useEffect(() => {
        // Only import the specific flag image needed
        const loadImage = async () => {
            try {
                let imagePath;
                switch (region_code) {
                    case 'us-west-1':
                    case 'us-east-1':
                    case 'us-central-1':
                    case 'store-obj2':
                        imagePath = await import('../../static/img/flag/ic-flag--usa.svg');
                        break;
                    case 'ca-central-1':
                        imagePath = await import('../../static/img/flag/ic-flag--ca.svg');
                        break;
                    case 'eu-central-1':
                        imagePath = await import('../../static/img/flag/ic-flag--nl.svg');
                        break;
                    case 'eu-central-2':
                        imagePath = await import('../../static/img/flag/ic-flag--de.svg');
                        break;
                    case 'eu-west-1':
                        imagePath = await import('../../static/img/flag/ic-flag--uk.svg');
                        break;
                    case 'eu-west-2':
                        imagePath = await import('../../static/img/flag/ic-flag--fr.svg');
                        break;
                    case 'ap-northeast-1':
                    case 'ap-northeast-2':
                        imagePath = await import('../../static/img/flag/ic-flag--ja.svg');
                        break;
                    case 'ap-southeast-1':
                        imagePath = await import('../../static/img/flag/ic-flag--sg.svg');
                        break;
                    case 'ap-southeast-2':
                        imagePath = await import('../../static/img/flag/ic-flag--au.svg');
                        break;
                    case 'eu-south-1':
                        imagePath = await import('../../static/img/flag/ic-flag--it.svg');
                        break;
                    default:
                        imagePath = null;
                }
                setFlagImage(imagePath?.default);
            } catch (error) {
                console.error('Failed to load flag image:', error);
            }
        };

        loadImage();
    }, [region_code]);

    return (
        <div className="mf-group cursor-pointer">
            <div className="mf-group__ic mf-group__ic--flag mt-14 mb-14">
                <img src={flagImage} alt={t(`@${region_code}@`)}/>
            </div>
            {!with_link && <div className="mf-group__text ng-binding">{t(`@${region_code}@`)}</div>}
            {with_link && <div className="mf-group__text"><a href={genLink(region_code)} target="_blank">{t(`@${region_code}@`)}</a></div>}
        </div>
    );
}

export default React.memo(CloudSpaceRegionComponent);